<template>
  <div>
    <el-row>
      <el-col align="right" style="height: 40px;" v-if="contractStatus === 80">
        <el-button type="primary" @click="handleAddService" v-if="type !== 'customer' && !dataList.length">新增</el-button>
        <el-button type="primary" @click="handleAddService" v-if="type === 'customer'">新增</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="订单编号" min-width="100" align="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.deliver(scope.row.id, '_blank')">{{scope.row.orderNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" align="left" prop="orderStatusDesc">
      </el-table-column>
      <el-table-column label="商机" align="center" prop="businessScaleDesc">
          <template slot-scope="scope">
            <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.business(scope.row.businessId, '_blank')">{{scope.row.businessName}}</el-link>
          </template>
      </el-table-column>
      <el-table-column label="合同编号" align="center">
        <template slot-scope="scope">
            <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.contract(scope.row.contractId, '_blank')">{{scope.row.contractNum}}</el-link>
          </template>
      </el-table-column>
      <el-table-column label="合同金额(元)" xalign="center" prop="estimateDealAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(Number(scope.row.contractAmount || 0)) }}元</span>
        </template>
      </el-table-column>
      <el-table-column label="发货日期" align="center" prop="expressDate"/>
      <el-table-column label="交付日期" align="center" prop="deliveryDate"/>
      <el-table-column label="服务订单" align="center" prop="serviceOrderCount">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="goServiceList(scope.row.orderNum)">{{scope.row.serviceOrderCount}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="负责人" align="center" prop="managerName"/>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
    <!-- 新增交付单 -->
    <DeliveryOrderAddDialog ref="deliveryOrderAddDialogRef" @success="queryList"></DeliveryOrderAddDialog>
  </div>
</template>

<script>
import {
  listDeliveryByPage, // 查询服务订单
} from "@/api/crm/order"; 
import { amountFormat } from "@/utils/index";
import DeliveryOrderAddDialog from "@/views/crm/delivery/deliveryOrderAddDialog"
import ServiceOrderAddDialog from "@/views/crm/service/serviceOrderAddDialog";

export default {
  name: "DeliverList",
  props: {
    customerId: {},
    contractId: {},
    type: {
      type: String,
      default: ''
    },
    contractStatus: { // 合同只有已签约的可以可以添加交付单
      type: Number,
      default: 80
    },
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      amountFormat,
      total: 0,
      otherData: {
        totalContractAmount: 0, // 合同总额
        totalSignContractAmount: 0, // 已签约
        totalFundedAmount: 0 // 已回款
      },
      queryParams: {
        pageNum: 1,
        pageSize: 20
      }
    };
  },
  created() {
    if (this.customerId || this.contractId) {
      this.queryList();
    }
  },
  components: {
    DeliveryOrderAddDialog
  },
  watch: {
    customerId(val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = [];
      }
    },
    contractId(val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = [];
      }
    },
  },
  methods: {
    /** 新增服务按钮操作 */
    handleAddService() {
      this.$refs.deliveryOrderAddDialogRef.open(this.customerId, this.contractId);
    },
    queryList() {
      this.loading = true;
      listDeliveryByPage({
        ...this.queryParams,
        customerId: this.customerId,
        contractId: this.contractId
      })
        .then(response => {
          const { total, otherData, rows, msg, code } = response;
          this.loading = false;
          if (code == 200) {
            this.dataList = rows || [];
            this.total = total;
            this.otherData = otherData || {};
            this.$emit("after-query", this.dataList);
          } else {
            this.$message.error(msg || "服务单列表获取异常");
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message.error(error.msg || "服务单列表获取异常");
        });
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      window.open("/crm/contract/detail/" + row.id, "_blank");
    },
    toUserDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank");
    },
    /** 详细按钮操作 */
    toBusinessDetail(row) {
      window.open("/crm/business/detail/" + row.businessId, "_blank");
    },
    // 跳转服务单列表
    goServiceList(deliveryOrderNum) {
      window.open(`/crm/serviceOrder?deliveryOrderNum=${deliveryOrderNum}`, '_blank')
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .pagination-container {
  padding: 10px 0px 32px !important;
}
</style>
